export default __webpack_public_path__ + "static/Event4-61afe83ecfb793c96656592b4c1e4f90.jpg";